import { Inject, Injectable } from '@angular/core';
import { HANDLER_REQUEST } from '@shared/constants/exportations';
import { RestMethod } from '@shared/enums/rest-method';
import { IRestInfraestructureService } from '@shared/interfaces/rest/IRestInfraestructureService';
import { IRequestParams } from '@shared/interfaces/rest/Irequest-params';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IListResponse } from '@core/interfaces/iResponse';
import { Plant } from '@shared/interfaces/certify/laboratories.interface';
import { Region, UrbanArea } from '@shared/interfaces/certify/urban-area';
import { ViewPlantByRegionEnum } from 'src/app/pages/certify/constants/enums/view-plant-by-region.enum';
import { PlantByRegion } from '@shared/interfaces/certify/createRecipeFilters.interface';

@Injectable({
  providedIn: 'root',
})
export class CatService {
  params!: IRequestParams;

  constructor(
    @Inject(HANDLER_REQUEST) private handler: IRestInfraestructureService,
    private cookieService: CookieService,
  ) {}

  GetAreas(withTTL: boolean = true, loader: boolean = true): Observable<IListResponse<UrbanArea>> {
    this.params = {
      point: 'GetUrbanArea',
      verb: RestMethod.GET,
      ...(withTTL ? { ttlMinutes: 1 } : {}),
      showLoad: loader,
    };
    return this.handler.sendRequest<IListResponse<UrbanArea>>(this.params);
  }

  GetRegionByArea(areaId: number, withTTL: boolean = true, loader: boolean = true): Observable<any> {
    this.params = {
      point: 'GetRegionsByArea',
      verb: RestMethod.GET,
      fullparameter: `/${areaId}`,
      ...(withTTL ? { ttlMinutes: 1 } : {}),
      showLoad: loader,
    };
    return this.handler.sendRequest(this.params);
  }

  GetPlantsByRegion(
    regionId: any,
    viewPlant: number = ViewPlantByRegionEnum.All,
    withTTL: boolean = true,
    loader: boolean = true,
  ): Observable<any> {
    this.params = {
      point: 'GetPlantsByRegion',
      verb: RestMethod.POST,
      body: {
        regionId,
        ViewPlant: viewPlant,
      },
      ...(withTTL ? { ttlMinutes: 1 } : {}),
      showLoad: loader,
    };
    return this.handler.sendRequest(this.params);
  }

  GetPlantsByCompany(withTTL: boolean = true, loader: boolean = true): Observable<any> {
    const userGuid = this.cookieService.get(environment.UserGuid).toUpperCase().toUpperCase();
    const companyGuid = this.cookieService.get(environment.CompanyGuid).toUpperCase().toUpperCase();

    this.params = {
      point: 'GetPlantsByCompany',
      verb: RestMethod.GET,
      fullparameter: `userGuid=${userGuid}&companyGuid=${companyGuid}`,
      ...(withTTL ? { ttlMinutes: 1 } : {}),
      showLoad: loader,
    };

    this.handler.sendRequest(this.params);
    return of('');
  }

  /**
   * Getting plants (excluding dummies)
   * @returns actives plants
   */
  public getPlantsByRegion(baseParameters: string, withTTL: boolean = true): Observable<IListResponse<Plant>> {
    this.params = {
      point: 'GetAllPlants',
      verb: RestMethod.GET,
      fullparameter: `filters=${baseParameters}`,
      showLoad: false,
      ...(withTTL ? { ttlMinutes: 1 } : {}),
    };

    return this.handler.sendRequest<IListResponse<Plant>>(this.params);
  }

  /**
   * Getting all regions
   * @returns Regions
   */
  public getAllRegions(withTTL: boolean = true): Observable<IListResponse<Region>> {
    this.params = {
      point: 'GetAllRegions',
      verb: RestMethod.GET,
      ...(withTTL ? { ttlMinutes: 1 } : {}),
    };
    return this.handler.sendRequest(this.params);
  }

  /**
   * Getting all plants of user session(excluding dummies) by filters
   * @param filters: filter (name or code) to search plants, regionId: filter by region
   */
  public getCurrentPlants(filters: string): Observable<IListResponse<PlantByRegion>> {
    this.params = {
      point: 'CurrentPlants',
      verb: RestMethod.GET,
      fullparameter: `filters=${filters}`,
    };
    return this.handler.sendRequest(this.params);
  }
}
